// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback, useEffect, useRef } from 'react';

import isNil from 'lodash/isNil';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireOperationalEvent } from '@atlassian/ui-modifications-analytics';

import { useAppErrors } from '../../../../../../../controllers/issue-adjustments/hooks/use-app-errors';
import { useViewType } from '../../../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { useIssueAdjustmentsActions } from '../../../../../../../controllers/issue-adjustments/main';

import type { ErrorCallback, SubscribeToErrors } from './types';

type UseOnErrorSubscriptionsProps = {
	appId: string;
};

export const useOnErrorSubscription = ({ appId }: UseOnErrorSubscriptionsProps) => {
	const viewType = useViewType();
	const notifyAppRef = useRef<ErrorCallback | null>(null);
	const { appErrors } = useAppErrors({ appId });
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { resetAppErrors } = useIssueAdjustmentsActions();

	useEffect(() => {
		const notifyApp = notifyAppRef.current;

		if (isNil(appId) || notifyApp === null || appErrors === null) {
			return;
		}

		notifyApp({
			errors: appErrors,
		});

		fireOperationalEvent(createAnalyticsEvent, {
			action: 'success',
			actionSubject: 'jiraUiModifications.appNotification',
			attributes: {
				lifecycleEvent: 'appError',
				viewType,
			},
		});

		resetAppErrors({ appId });
	}, [createAnalyticsEvent, resetAppErrors, appErrors, appId, viewType]);

	return useCallback<SubscribeToErrors>((callback) => {
		notifyAppRef.current = callback;
	}, []);
};
